module.exports = __webpack_public_path__ + "static/DFP-efc48cb4556b87d5573b1546457f1379.png";